import { render, staticRenderFns } from "./PostDocReview.vue?vue&type=template&id=69aa2394&"
import script from "./PostDocReview.vue?vue&type=script&lang=js&"
export * from "./PostDocReview.vue?vue&type=script&lang=js&"
import style0 from "./PostDocReview.vue?vue&type=style&index=0&id=69aa2394&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports